export { default } from './ContestList';



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestList/index.js